var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "bgPanel rounded-md" },
    [
      _c(
        "v-skeleton-loader",
        _vm._b(
          { staticClass: "rounded-md", attrs: { type: "card-heading" } },
          "v-skeleton-loader",
          _vm.attrs,
          false
        )
      ),
      _c(
        "v-col",
        { staticClass: "pa-0 mb-2", attrs: { cols: "6" } },
        [
          _c(
            "v-skeleton-loader",
            _vm._b(
              {
                staticClass: "document-skeleton rounded-md",
                attrs: { type: "list-item-three-line" },
              },
              "v-skeleton-loader",
              _vm.attrs,
              false
            )
          ),
        ],
        1
      ),
      _c(
        "v-skeleton-loader",
        _vm._b(
          {
            staticClass: "document-skeleton rounded-md",
            attrs: { type: "actions" },
          },
          "v-skeleton-loader",
          _vm.attrs,
          false
        )
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }